<template>
    <div class="admin-footer">
        <div class="page-loader-wrapper loading-container" style="display: none;">
            <div class="loading">
                <img src="/static/images/loading.gif">
            </div>
        </div>
        &copy; {{currentYear}} Velocity Vehicle Group. All Rights Reserved. 
    </div>
</template>
<script>
    // import { headers } from "../config";
    import {list_customerUrl, configs} from '../../config';
    import SessioMixin from '../../mixins/sessionmixin';
    import Vue from 'vue';
    import {listCustomer} from '../../config';
    import EventBus from '../event-bus';


    export default {
        name: "Footer",
        mixins: [SessioMixin],
        data: () => ({
                currentYear: '2019',
            }),

        mounted: function () {
            var app = this;
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                app.loginID = userJson.id;
                //console.log(app.loginID);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            var appYear = localStorage.getItem('app_year');
            if (typeof (appYear) != "undefined") {
                if (appYear != null) {
                    app.currentYear = appYear;
                }
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

        },
        methods: {
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/partials/FrontFooter.vue